"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var handleTagClassName = function handleTagClassName(tagName, className, condition) {
  return document.querySelector(tagName).classList.toggle(className, condition);
};
exports.default = handleTagClassName;
//# sourceMappingURL=handleTagClassName.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/handleTagClassName.js